import { IHttpHeadResponse } from './IHttpHeadResponse';

export class HttpRequest {

    static sendRangeRequest(url: string, start: number, end: number): Promise<ArrayBuffer> {
        return new Promise<ArrayBuffer>((resolve, reject) => {
            let request = HttpRequest.createRequest('GET', url, reject);

            request.setRequestHeader("Range", `bytes=${start}-${end}`);
            request.onload = () => {
                resolve(request.response);
            };
            request.send();
        });
    }


    static sendHeadRequest(url: string): Promise<IHttpHeadResponse> {
        return new Promise<IHttpHeadResponse>((resolve, reject) => {

            let request = HttpRequest.createRequest('HEAD', url, reject);

            request.onload = () => {
                try {
                    let contentLengthStr = request.getResponseHeader('Content-Length');
                    if (!contentLengthStr) {
                        reject('Missing Content-Length header');
                        return;
                    }
                    let contentLength = parseInt(contentLengthStr, 10);
                    if (isNaN(contentLength)) {
                        reject('Invalid Content-Length: ' + contentLengthStr);
                    }

                    resolve({
                        contentLength: contentLength,
                        contentType: request.getResponseHeader('Content-Type')
                    });
                } catch (e) {
                    reject(e);
                }
            };

            request.send();
        })
    }

    private static createRequest(verb: 'GET' | 'HEAD', url: string, rejectFn: (arg?: any) => void): XMLHttpRequest {

        let request = new XMLHttpRequest();
        request.open(verb, url , true);
        request.responseType = "arraybuffer";

        request.onerror = () => {
            rejectFn(request.status + ': ' + request.statusText);
        };

        request.onabort = () => {
            rejectFn(request.status + ': ' + request.statusText);
        };

        request.ontimeout = () => {
            rejectFn('TIMEOUT');
        };

        return request;
    }
}
